import React from "react";
import { IPerson } from "../../../interfaces";
import type { IPhoneNumber } from "../../staff/PhoneNumber";
import { formatPhoneForDisplay } from "../../../utils/formatPhoneForDisplay";
import EmailIcon from "../../Atomos/Icons/EmailIcon";
import VerticalSeparator from "../../Atomos/Icons/VerticalSeparator";
import { Link } from "react-router-dom";
import ProfilePhoto from "../../Atomos/ProfilePhoto";
import { resolveProfilePictureDisplayUrl } from "../../../utils/profilePictureUrl";

interface ShortPersonCardProps {
  person?: IPerson;
  className?: string;
  additionalInfo?: string;
}

const ShortPersonCard: React.FC<ShortPersonCardProps> = ({
  person,
  className,
  additionalInfo,
}) => {
  const photoSrc = person?.id
    ? resolveProfilePictureDisplayUrl(person.id, person.photo, {
        photoUpdatedAt: person._ts,
      })
    : "";

  return (
    <React.Fragment>
      <div
        className={`${className} flex p-0 items-center gap-6 lg:gap-[.625rem] lg:flex-1 self-stretch rounded-lg overflow-hidden`}
      >
        <div className="flex lg:flex-col lg:items-center lg:gap-1">
          <div className="w-[5.5rem] h-[5.5rem] rounded-full bg-gray-100 overflow-hidden">
            <ProfilePhoto src={photoSrc} />
          </div>
        </div>
        <div className="flex flex-col items-center gap-1 self-stretch max-w-[12rem] lg:max-w-[15rem] overflow-hidden">
          <Link
            to={`/profile/attorney/${person?.name?.trim()}-${person?.lastName?.trim()}/${person?.legacyId ?? person?.generatedId}`}
            className="text-Default lg:text-xl lg:leading-7 font-bold self-stretch overflow-hidden text-ellipsis whitespace-nowrap w-full"
          >
            {person?.name} {person?.lastName}
          </Link>

          <span className="text-gray-font lg:text-[1.125rem] lg:leading-5 self-stretch overflow-hidden text-ellipsis whitespace-nowrap w-full">
            {person?.title}
          </span>

          <div className="flex lg:items-start lg:gap-2 self-stretch">
            <span className="text-gray-font lg:text-[1.125rem] lg:leading-5 overflow-hidden text-ellipsis whitespace-nowrap max-w-[10rem]">
              {formatPhoneForDisplay(
                person?.phoneNumber as string | IPhoneNumber | undefined
              )}
            </span>
            <div className="w-1 h-[1.25rem]">
              <VerticalSeparator />
            </div>
            <div className="flex p-1 justify-center items-center gap-[.625rem] rounded-full bg-Default">
              <div className="w-3 h-3">
                <EmailIcon />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ShortPersonCard;
